<template>
    <div>
        <div>
            <product-search style="float:left;width:100%;text-align:right;"
                            :products-to-search="products"
                            :review="review"
                            @searchresults="loadSearchResults"></product-search>
        </div>
        <div class="fixed-table">
            <table>
                <thead>
                <tr>
                    <th style="width:50%;text-align:left;">product</th>
                    <th style="width:10%;">
                        <div v-if="dairy.bypassOrderEntry">case qty</div>
                        <div v-else>units per</div>
                    </th>
                    <th style="width:15%;">packaging</th>
                    <th style="width:15%;">units</th>
                    <th v-if="dairy.showPrice" style="width:10%;">price per</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="product in productsToDisplay"
                    :key="product.id"
                    v-show="product.visible"
                    id="order-product-row">
                    <td style="width:50%;">
                        <div :class="product.outOfStock ? 'outOfStock' : ''" style="font-weight:bold;padding:0;">
                            <sup>[{{ product.id }}]</sup>&nbsp;{{ product.name }}
                        </div>
                    </td>
                    <td style="width:10%;font-size:10pt;font-weight:normal;font-style:italic;text-align:center;">
                        {{ product.packText ? product.packText : product.unitsPerPackaging }}
                    </td>
                    <td style="width:15%;text-align:center;">
                        <tool-tip-error v-if="(product.packagings * product.unitsPerPackaging) > QUANTITY_MAXIMUM"
                                        text="too large"
                                        type="packagings"/>
                        <input v-if="product.fullPackaging"
                               v-model="product.packagings"
                               class="quantity-input"
                               :class="packagingsInputClass(product)"
                               type="text"
                               @keypress="validateNumber"
                               :disabled="review || product.outOfStock"/>
                    </td>
                    <td style="width:15%;text-align:center;">
                        <tool-tip-error v-if="product.units > QUANTITY_MAXIMUM"
                                        text="too large"
                                        type="units"/>
                        <input v-if="!product.fullPackaging"
                               v-model="product.units"
                               :name="'units_' + product.id"
                               class="quantity-input"
                               :class="unitsInputClass(product)"
                               type="text"
                               @keypress="validateNumber"
                               :disabled="review || product.outOfStock"/>
                    </td>
                    <td v-if="dairy.showPrice" style="width:10%;text-align:right;">
                        {{
                        product.pricePer.toLocaleString(
                            'en-US', {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 4,
                            }
                        )
                        }}
                    </td>

                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <th style="width:800px">
                        <order-total :dairy="dairy"
                                     :products="products"
                                     :columns="4"
                                     :min="QUANTITY_MINIMUM"
                                     :max="QUANTITY_MAXIMUM"
                                     @hasunits="loadHasUnits"
                                     @isvalid="loadQuantitySentinel">
                        </order-total>
                    </th>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import OrderTotal from '@/components/ordering/OrderTotal'
import ProductSearch from '@/components/ordering/products/Search'
import ToolTipError from '@/components/tooltip/TooltipError'

const QuantityMinimum = 0
const QuantityMaximum = 99999

export default {
    name: 'OrderList',
    props: ['dairyId', 'customerId', 'priceDeck', 'review', 'iscopy', 'productstocopy'],
    emits: ['orderproducts', 'isvalid', 'hasunits', 'apierror', 'apierrortext'],
    data: function () {
        return {
            QUANTITY_MINIMUM: null,
            QUANTITY_MAXIMUM: null,
            dairy: {},
            products: [],
            productsToDisplay: [],
            quantitySentinel: false,
            valid: null,
        }
    },
    components: {
        ProductSearch,
        OrderTotal,
        ToolTipError,
    },
    methods: {
        loadSearchResults(results) {
            this.productsToDisplay = results
        },
        validateNumber: event => {
            const charCode = String.fromCharCode(event.keyCode);
            if (!/[0-9]/.test(charCode)) {
                event.preventDefault();
            }
        },
        loadHasUnits: function (hasUnits) {
            this.$emit('hasunits', hasUnits)
        },
        loadQuantitySentinel: function (isValid) {
            this.$emit('isvalid', isValid)
        },
        packagingsInputClass: function (product) {
            if ((product.packagings * product.unitsPerPackaging) < this.QUANTITY_MINIMUM || (product.packagings * product.unitsPerPackaging) > this.QUANTITY_MAXIMUM) {
                return 'invalid-indicator'
            } else if (this.review) {
                return 'review'
            }
        },
        unitsInputClass: function (product) {
            if (product.units < this.QUANTITY_MINIMUM || product.units > this.QUANTITY_MAXIMUM) {
                return 'invalid-indicator'
            } else if (this.review) {
                return 'review'
            }
        },
    },
    watch: {
        review: function (isReview) {
            if (isReview) {
                for (const product of this.products) {
                    product.visible = (parseInt(product.units) > 0 || parseInt(product.packagings) > 0)
                }
                this.$emit('orderproducts', this.products)
            }
        },
    },
    created() {
        this.QUANTITY_MINIMUM = QuantityMinimum
        this.QUANTITY_MAXIMUM = QuantityMaximum
    },
    mounted() {
        this.$emit('isvalid', false)
        this.products = []

        this.axios
            .get('account/products', {
                params: {
                    dairyId: this.dairyId,
                    priceDeck: this.priceDeck,
                    accountId: this.customerId,
                }
            })
            .then(response => {
                this.dairy = response.data.dairy

                response.data.products.forEach(
                    product => {
                        product.units = ''
                        product.packagings = ' '
                        product.visible = true
                        product.rank = 999999999
                    }
                )

                if (this.iscopy) {
                    for (const product of this.productstocopy) {
                        let pointer = response.data.products.findIndex((obj => obj.id === product.id))

                        if (pointer !== -1) {
                            if (!response.data.products[pointer].outOfStock) {
                                if (response.data.products[pointer].fullPackaging) {
                                    response.data.products[pointer].packagings = product.packagings
                                    response.data.products[pointer].units = 0
                                } else {
                                    response.data.products[pointer].packagings = 0
                                    response.data.products[pointer].units = product.units
                                }
                            }

                            response.data.products[pointer].rank = product.sortSequence
                        }
                    }
                }

                response.data.products = _.sortBy(response.data.products, ['rank', 'sortSequence'])

                this.products = response.data.products
                this.productsToDisplay = this.products
                this.$emit('orderproducts', this.products)
            })
            .catch(error => {
                this.$emit('apierror', true)
                this.$emit('apierrortext', error.response.statusText)
            })
    },
}
</script>

<style scoped>
.fixed-table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
}

.fixed-table thead tr {
    display: block;
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    border-top-left-radius: 5px;
    border-right: 1px solid #000;
    border-top-right-radius: 5px;
}

.fixed-table tfoot tr {
    display: block;
    border-bottom: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom-left-radius: 5px;
    border-right: 1px solid #000;
    border-bottom-right-radius: 5px;
}

.fixed-table th {
    background: darkgray;
    color: black;
}

.fixed-table tbody {
    display: block;
    overflow: auto;
    height: 290px;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
}

.fixed-table th,
.fixed-table td {
    padding: 5px 10px;
    height: 30px;
    width: 200px;
    white-space: nowrap;
}

th {
    background: #ABDD93;
}
</style>
